import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import { TablesPeaksProgressTeachersComponent } from 'teacher-ui-client/components/tables/peaks-progress/teachers'
import type FastPhonicsReportingProgressReviewTeachersRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/review/teachers/route'
import type FastPhonicsReportingProgressReviewTeachersController from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/review/teachers/controller'

interface Signature {
  Args: {
    model: ModelFor<FastPhonicsReportingProgressReviewTeachersRoute>
    controller: FastPhonicsReportingProgressReviewTeachersController
  }
}

export const FastPhonicsProgressReviewTeachersPage: TOC<Signature> = <template>
  <TablesPeaksProgressTeachersComponent
    @teachers={{@model.teacherItems}}
    @isLoadingItems={{@model.loadTeacherDataTask.isRunning}}
    @onSortClick={{@controller.updateSorts}}
    @sortingConfig={{@controller.sortingConfig}}
    @exportable={{true}}
  />
</template>

export default RouteTemplate(FastPhonicsProgressReviewTeachersPage)
